import {createRouter, createWebHistory, RouterView} from 'vue-router'
import HomePage from "@/pages/home-page.vue";
import translation from "@/core/helpers/translations.js";
import FaqPage from "@/pages/faq-page.vue";
import PolicyPage from "@/pages/policy-page.vue";
import TermsPage from "@/pages/terms-page.vue";
import StorePage from "@/pages/store-page.vue";
import CartPage from "@/pages/cart-page.vue";
import ProfilePage from "@/pages/profile-page.vue";
import {checkAuth} from "@/core/guards/notAuthGuard.js";
const routes = [
  {
    path: '/:locale?',
    component: RouterView,
    beforeEnter: translation.routeMiddleware,
    children: [
      {
        path: '',
        name: 'home',
        component: HomePage,
        meta: {
          title: 'Home'
        }
      },
      {
        path: 'activate-user',
        name: 'activate-user',
        component: HomePage,
        meta: {
          title: 'Home'
        }
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: HomePage,
        meta: {
          title: 'Confirm Password'
        }
      },
      {
        path: 'store',
        name: 'store',
        component: StorePage,
        meta: {
          title: 'Store'
        }
      },
      {
        path: 'store',
        name: 'search',
        component: StorePage,
        meta: {
          title: 'Search'
        }
      },
      {
        path: 'cart',
        name: 'cart',
        component: CartPage,
        beforeEnter: checkAuth,
        meta: {
          title: 'Cart'
        }
      },
      {
        path: 'profile',
        name: 'profile',
        component: ProfilePage,
        beforeEnter: checkAuth,
        meta: {
          title: 'Profile'
        }
      },
      {
        path: 'faq',
        name: 'faq',
        component: FaqPage,
        meta: {
          title: 'FAQ'
        }
      },
      {
        path: 'policy',
        name: 'policy',
        component: PolicyPage,
        meta: {
          title: 'Policy'
        }
      },
      {
        path: 'terms',
        name: 'terms',
        component: TermsPage,
        meta: {
          title: 'Terms'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    document.querySelector('#top').scrollIntoView({ behavior: 'smooth' })
    return {
      top: 0,
      left: 0,
      behavior: 'smooth'
    }
  }
})

router.beforeEach((to, from) => {
  document.title = to.meta.title ? 'GiftCardEase | ' + to.meta?.title : 'GiftCardEase'
})

export default router
